import React, {Component} from 'react';
import MenuComponent2 from './MenuComponent2';
import AuthenticationService from '../services/AuthenticationService';
import MaterialTab from './MaterialTab';
import XiListTab from './XiListTab';
import MaterialTabSuper from './MaterialTabSuper';


class MaterialStock extends Component{
    constructor() {
        super();
    };                 

    render(){
        if(!AuthenticationService.isAdmin() && !AuthenticationService.isSupervisor() && !AuthenticationService.isXi()){
            return (<div>Unauthorized access.</div>);
        }

        if (AuthenticationService.isSupervisor()){
            return (
                <div>
                    <MenuComponent2 />
                    <div className="row">
                        <div className="col-12">
                            <MaterialTabSuper />
                        </div>
                    </div>
                </div>
            );
        }
        
        return (
            <div>
                <MenuComponent2 />
                <div className="row">
                    <div className="col-12">
                        <MaterialTab />
                    </div>
                </div>
            </div>
        );
    }
}

export default MaterialStock;
